import React from 'react';
import { footer } from '../data/content';
export function Footer() {
  return <footer className="bg-teal-dark pb-28 pt-10 md:pb-10" data-id="element-72" data-mp="3gezcx2w41p0m">
      <div className="mx-auto flex max-w-page flex-col items-center gap-2 px-5 text-center text-[13px] text-white/70 md:px-8" data-id="element-73" data-mp="3ggk6oqalp3xf">
        <p className="text-white/90" data-id="element-74" data-mp="36pft9v0kpr4p">{footer.line}</p>
        <p data-id="element-75" data-mp="36q94b86kf2sn">
          {footer.supportLabel}{' '}
          <a href={`mailto:${footer.supportEmail}`} className="text-gold underline-offset-4 hover:underline" data-id="element-76" data-mp="3uf0lz5mj42r6">
            {footer.supportEmail}
          </a>
        </p>
        <p data-id="element-77" data-mp="37xuse6oxwgy">{footer.copyright}</p>
      </div>
    </footer>;
}